import React from 'react';
import { Typography, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileTimes } from '@fortawesome/pro-regular-svg-icons';
import { HwtButton } from 'components/@common/Buttons/HwtButton';

type Props = {
  title: string;
  subtitle: string;
  buttonTitle: string;
  handleNoDataClick: () => void;
};
export const SATableNoData: React.FC<Props> = ({
  title,
  subtitle,
  buttonTitle,
  handleNoDataClick
}) => {
  const classes = useStyles();
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        justifyContent="space-between"
        mt={18}
        mb={18}
      >
        <FontAwesomeIcon size="6x" icon={faFileTimes} />
        <Typography variant="h5" className={classes.boxTitle}>
          {title}
        </Typography>
        <Typography variant="subtitle2">{subtitle}</Typography>
        <HwtButton style={{ width: '250px' }} variant="contained" onClick={handleNoDataClick}>
          {buttonTitle}
        </HwtButton>
      </Box>
    </>
  );
};

const useStyles = makeStyles(() => ({
  boxTitle: { paddingTop: '20px', paddingBottom: '10px' }
}));
